import React from "react";
import styles from "./SkeletonLoader.module.css";

/**
 * A generic skeleton loader component.
 *
 * @param {string} className - Optional, for custom styling/layout.
 * @param {object} style - Optional, for inline styling.
 * @returns {JSX.Element}
 */
const SkeletonLoader = ({ className = "", style = {} }) => {
  return (
    <div
      className={`${styles.skeletonLoader} ${className}`}
      style={style}
    />
  );
};

export const generateDummyObject=(count)=>{
  return Object.fromEntries(
    Array.from({ length: count }, (_, i) => {
      const val = (i + 1).toString();
      return [val, val];
    })
  );
}

export const generateArrayOfDummyObjects = (arrCount, objCount) => {
  return Array.from({ length: arrCount }, () =>
    generateDummyObject(objCount)
  );
};

export default SkeletonLoader;